import { INITIAL_LOAD } from '../constants';

export interface AppReducerState {
    loading: Boolean;
}

interface Payload { }

interface Action {
    type: string;
    payload: Payload;
}

const initialState = {
    loading: false
};

const appReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case INITIAL_LOAD:
            return {
                ...state,
                loading: true
            };
        default:
            return {
                ...state
            };
    }
};

export default appReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/reducers/appReducer.ts